<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :close-on-click-modal="false"
    class="dialog-dark"
    :title="$t('lucking.抽奖')"
    width="454px"
  >
    <div>
      <img class="lucking-img" src="@/assets/images/lucking.png" />
    </div>
    <div slot="footer" class="lucking-footer">
      <el-button :loading="isLoading" class="button-mini" type="danger" size="mini" @click="start"
        >{{$t('lucking.停止抽奖')}}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { Dialog } from "element-ui";
import { startLuckDraw } from "@/api/liveRequest/luckDawApi";
export default {
  name: "Lucking",
  components: {
    [Dialog.name]: Dialog,
  },
  props: {
    config: Object,
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    start() {
      this.isLoading = true
      startLuckDraw(Object.assign({}, this.config, {
        webcastId: this.$route.params.liveId
      })).then(async (res) => {
        if (res?.code == 200 && res.data?.raffleId) {
          this.$emit('result', res.data.raffleId)
        } else {
          this.$emit('result', null)
        }
        this.$emit('update:visible', false)
      }).finally(() => {
        this.isLoading = false
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.lucking-img {
  width: 238px;
  height: 182px;
  display: block;
  margin: 0 auto 8px;
}
.lucking-footer {
  text-align: center;
}
</style>
